module.exports = __webpack_public_path__ + "static/media/virksomhed_banner.dd61d7f0.png";